var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.canInteract)?_c('div',[_c('gift-creator-post',{attrs:{"creatorPost":_vm.creatorPost}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }